import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetail from "@/pages/ServiceDetail";
import CitiesIndex from "@/pages/CitiesIndex";
import CitiesByState from "@/pages/CitiesByState";
import CityDetail from "@/pages/CityDetail";
import JoinHub from "@/pages/JoinHub";
import HaulersSignup from "@/pages/HaulersSignup";
import AffiliateSignup from "@/pages/AffiliateSignup";
import LargeJobs from "@/pages/LargeJobs";
import Consulting from "@/pages/Consulting";
import News from "@/pages/News";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import GenericQuote from "@/pages/GenericQuote";
import SalesTeam from "@/pages/SalesTeam";
import Intel from "@/pages/Intel";
import TranslateHub from "@/pages/TranslateHub";
import Exchange from "@/pages/Exchange";
import ExchangeListingDetail from "@/pages/ExchangeListingDetail";
import ExchangePost from "@/pages/ExchangePost";
import ExchangeMembers from "@/pages/ExchangeMembers";
import ExchangeMemberProfile from "@/pages/ExchangeMemberProfile";
import ExchangeHonor from "@/pages/ExchangeHonor";
import ClosedDealsWall from "@/pages/ClosedDealsWall";
import AvailableMe from "@/pages/AvailableMe";
import AvailableMeCompose from "@/pages/AvailableMeCompose";
import Developers from "@/pages/Developers";
import Defenders from "@/pages/Defenders";
import DefendersJoin from "@/pages/DefendersJoin";
import DefendersIntake from "@/pages/DefendersIntake";
import Motions from "@/pages/Motions";
import MotionDetail from "@/pages/MotionDetail";
import MotionsSubmit from "@/pages/MotionsSubmit";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/service/:slug" element={<ServiceDetail />} />
            <Route path="/cities" element={<CitiesIndex />} />
            <Route path="/cities/:code" element={<CitiesByState />} />
            <Route path="/city/:slug" element={<CityDetail />} />
            <Route path="/join" element={<JoinHub />} />
            <Route path="/join/haulers" element={<HaulersSignup />} />
            <Route path="/join/affiliates" element={<AffiliateSignup program="marketing" />} />
            <Route path="/join/link-sharing" element={<AffiliateSignup program="link_sharing" />} />
            <Route path="/large-jobs" element={<LargeJobs />} />
            <Route path="/consulting" element={<Consulting />} />
            <Route path="/news" element={<News />} />
            <Route path="/quote" element={<GenericQuote />} />
            <Route path="/join/sales-team" element={<SalesTeam />} />
            <Route path="/intel" element={<Intel />} />
            <Route path="/translate" element={<TranslateHub />} />
            <Route path="/exchange" element={<Exchange />} />
            <Route path="/exchange/post" element={<ExchangePost />} />
            <Route path="/exchange/members" element={<ExchangeMembers />} />
            <Route path="/exchange/member/:handle" element={<ExchangeMemberProfile />} />
            <Route path="/exchange/honor" element={<ExchangeHonor />} />
            <Route path="/exchange/closed-deals" element={<ClosedDealsWall />} />
            <Route path="/exchange/listing/:id" element={<ExchangeListingDetail />} />
            <Route path="/availableme" element={<AvailableMe />} />
            <Route path="/availableme/compose" element={<AvailableMeCompose />} />
            <Route path="/developers" element={<Developers />} />
            <Route path="/defenders" element={<Defenders />} />
            <Route path="/defenders/join" element={<DefendersJoin />} />
            <Route path="/defenders/intake" element={<DefendersIntake />} />
            <Route path="/defenders/motions" element={<Motions />} />
            <Route path="/defenders/motions/submit" element={<MotionsSubmit />} />
            <Route path="/defenders/motions/:slug" element={<MotionDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
